import { ComponentType, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useNavigate } from 'react-router-dom';

export const auth = (Component: ComponentType) => {
	const Auth = (props: JSX.IntrinsicAttributes) => {
		const token = useSelector((state: RootState) => state?.user?.token);
		const navigate = useNavigate();

		useEffect(() => {
			if (!token) navigate('/');
			// eslint-disable-next-line
		}, []);

		return <Component {...props} />;
	};
	return Auth;
};
